(function () {

    function initSlidingPanels(component) {

        if (component.dataset.initialized === 'true') {
            return;
        }

        component.dataset.initialized = 'true';

        const tabs = Array.from(
            component.querySelectorAll('[data-panel-tab]')
        );

        const contents = Array.from(
            component.querySelectorAll('[data-panel-content]')
        );

        if (!tabs.length || !contents.length) {
            return;
        }

        function activatePanel(index) {

            tabs.forEach((tab, tabIndex) => {

                const active = tabIndex === index;

                tab.classList.toggle(
                    'is-active',
                    active
                );

                tab.setAttribute(
                    'aria-expanded',
                    active ? 'true' : 'false'
                );

            });

            contents.forEach((content, contentIndex) => {

                const active = contentIndex === index;

                /*
                 * Remove hidden before animation.
                 */
                contents.forEach((content, contentIndex) => {

                    content.classList.toggle(
                        'is-active',
                        contentIndex === index
                    );

                });

            });

        }

        tabs.forEach((tab, index) => {

            tab.addEventListener(
                'click',
                function () {
                    activatePanel(index);
                }
            );

        });

    }


    function initAllSlidingPanels(scope = document) {

        scope
            .querySelectorAll('[data-sliding-panels]')
            .forEach(initSlidingPanels);

    }


    if (document.readyState === 'loading') {

        document.addEventListener(
            'DOMContentLoaded',
            function () {
                initAllSlidingPanels();
            }
        );

    } else {

        initAllSlidingPanels();

    }


    /*
     * Gutenberg / ACF preview.
     */

    if (window.acf) {

        window.acf.addAction(
            'render_block_preview/type=filtronic/sliding-panels-shelf',
            function ($block) {

                $block
                    .find('[data-sliding-panels]')
                    .each(function () {
                        initSlidingPanels(this);
                    });

            }
        );

    }

})();